/* eslint-disable max-len, react/no-danger */
import React from 'react';
import Theme, { colors } from '../themes';

// TO DO: refactor to be more themystic
const linkColor = Theme.homes.main;
const fontColor = Theme.global.font;

const css = {
  __html: `
    html { background-color: ${
      colors.grayExtraLight
    }; box-sizing: border-box; cursor: default; -ms-text-size-adjust: 100%; -webkit-text-size-adjust: 100%; }
    body { background-color:#FFF;-webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; color:${fontColor}; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; margin: 0; padding: 0; }
    .blockScroll { position: relative; overflow: hidden; }
    a { color:${linkColor}; background-color: transparent; -webkit-text-decoration-skip: objects; text-decoration:none; }
    h1,h2,h3,h4,h5,h6 { font-weight: normal;margin:0; }
    *,
    ::before,
    ::after { background-repeat: no-repeat; box-sizing: inherit; }
    ::before,
    ::after { text-decoration: inherit; vertical-align: inherit; }
    ::-webkit-scrollbar { display: none; }
    article,
    aside,
    footer,
    header,
    nav,
    section { display: block; }
    nav ol,
    nav ul { list-style: none; }
    a:hover { text-decoration:underline; }
    b,
    strong { font-weight: bold; }
    small { font-size: 80%; }
    sup { font-size: 75%; line-height: 0; position: relative; vertical-align: baseline; top: -.5em; }
    iframe,
    img,
    svg { vertical-align: middle; }
    img { border-style: none; }
    svg,
    svg > use { fill: currentColor; color: currentColor; }
    svg:not(:root) { overflow: hidden; }
    table { border-collapse: collapse; }
    .clearfix { clear: both; content: ""; display: table; }
    button,
    input,
    select,
    textarea { background-color: transparent; color: inherit; font-size: inherit; line-height: inherit; margin: 0; outline: 0; }
    button,
    select { text-transform: none; }
    textarea { overflow: auto; resize: vertical; }
    button,
    html [type='button'],
    [type='reset'],
    [type='submit'] { -webkit-appearance: button; }
    [type='checkbox'],
    [type='radio'] { box-sizing: border-box; padding: 0; }
    [type='number']::-webkit-inner-spin-button,
    [type='number']::-webkit-outer-spin-button { height: auto; }
    [type='search'] {-webkit-appearance: none; }
    [type='search']::-webkit-search-cancel-button,
    [type='search']::-webkit-search-decoration { -webkit-appearance: none; }`
    .replace(/\n/gm, '')
    .replace(/\s+/g, ''),
};

export default () => <style dangerouslySetInnerHTML={css} />;



// WEBPACK FOOTER //
// ./app/common/GlobalCss.js